module.exports = "https://tutorchat.chegg.com/static/media/ic-select.540f7c0c.svg";